export default __webpack_public_path__ + "static/media/shipItemHome.ed6ed5b3.jpg";